<template>
  <div>
    <title>卡券总数</title>
    <section class="mainPart">
      <!--S 检索-->      
      <el-form :inline="true" :model="distributeForm" @submit.native.prevent>
        <el-form-item label=" ">
          <p class="textFl iconsc shopName" :title="queryInfo.flowname">{{queryInfo.flowname}}</p>
        </el-form-item>
        <el-form-item label="券卡类型">
          <el-autocomplete
            v-model="distributeForm.cardType"
            :fetch-suggestions="querySearchAsync"
            placeholder="请输入券卡类型"
            :maxlength="25"
            clearable
            v-if="ElementControls('accountbasis')!=1"
          >
          </el-autocomplete>
          <el-input clearable v-model="distributeForm.cardType" placeholder="请输入券卡类型" v-else></el-input>
        </el-form-item>
        <el-form-item label="出库时间">
          <!-- S 双日期选择器 -->
          <TwoDatePicker
            @twoDateObtain="outDateReceive"
            :startvaldate="distributeForm.outTime.length>0?distributeForm.outTime[0]:''"
            :endvaldate="distributeForm.outTime.length>0?distributeForm.outTime[1]:''"
            key="out">
          </TwoDatePicker>
          <!-- E 双日期选择器 -->
        </el-form-item>
        <el-form-item label="提货时间">
          <!-- S 双日期选择器 -->
          <TwoDatePicker
            @twoDateObtain="paiDateReceive"
            :startvaldate="distributeForm.paiTime.length>0?distributeForm.paiTime[0]:''"
            :endvaldate="distributeForm.paiTime.length>0?distributeForm.paiTime[1]:''"
            key="pai">
          </TwoDatePicker>
          <!-- E 双日期选择器 -->
        </el-form-item>
        <el-form-item label="由流向方发货">
            <el-select v-model="distributeForm.bbindflowsend" filterable placeholder="请选择或输入" @change="querySubmit" clearable>
                <el-option label="是" value="1"></el-option>
                <el-option label="否" value="0"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="querySubmit">查询</el-button>
          <el-button type="primary" plain @click="exportStatistics" v-if="payRecordList.length>0">导出商品汇总</el-button>
          <el-button type="primary" plain @click="exportAccountsCardDetail" v-if="payRecordList.length>0">导出券卡详细</el-button>
          <el-button type="primary" plain @click="$router.back(-1)">返回</el-button>
        </el-form-item>
      </el-form>
      <!--E 检索-->
      <!-- S 列表 -->
      <div class="gsListTable individualiz">
        <el-table class="comTable orderTable" ref="gsTable" :data="payRecordList" border :maxHeight="tableHeight" v-loading="loading">
          <el-table-column label="序号" type="index" fixed prop="serial"></el-table-column>
          <el-table-column label="券卡类型">
            <template slot-scope="scope">
              <span class="textFl pdr70" :title="scope.row.cardkind">{{scope.row.cardkind}}</span>
            </template>
          </el-table-column>
          <el-table-column label="卡券总数">
            <template slot-scope="scope">
              <p @click="toDetailPage(scope.row)" class="hand iconhand" title="点击查看详情">{{scope.row.num}}</p>
            </template>
          </el-table-column>
          <el-table-column label="总部总金额(￥)">
            <template slot-scope="scope">
              <span class="textFl" :title="scope.row.total">{{scope.row.total}}</span>
            </template>
          </el-table-column>
          <el-table-column label="门店总金额(￥)">
            <template slot-scope="scope">
              <span class="textFl" :title="scope.row.ltotal">{{scope.row.ltotal || '0.00'}}</span>
            </template>
          </el-table-column>
          <el-table-column label="券面总额(￥)">
            <template slot-scope="scope">
              <span class="textFl" :title="scope.row.allprice">{{scope.row.allprice || '0.00'}}</span>
            </template>
          </el-table-column>
          <template slot="empty">
              <div class="noData">
                  <span>暂无数据</span>
              </div>
          </template>
        </el-table>
      </div>
      <!-- E 列表 -->
      <!-- S 分页 -->
      <Page :pageTotal="pagebBean.totalnum" :currentPage="currentPage" @nowPageParam="updatePage"></Page>
      <!-- E 分页 -->
    </section>
  </div>
</template>
<script>
import api from '@/apis/api.js';
export default {
  name: 'PaymentCardTotal',
  data () {
    return {
      //检索
      distributeForm: {
        cardType: "", //关键词
        paiTime: [], // 提货时间
        outTime: [], // 出库时间
        bbindflowsend:'',
      },
      payRecordList:[],
      tableHeight: window.innerHeight*.8, //表格动态高度
      pageSize: 30, // 每页展示的条数
      currentPage: 1, // 当前请求的页数
      pagebBean: {
        totalnum: 0,
      }, // 获取到的列表分页信息
      queryInfo: '', // 传递过来的检索条件
      patchName: '', // 获取上一个页面的name
      loading: false, // 加载中
    }
  },
  filters: {

  },
  watch: {
    '$route'(to,from) {
      this.patchName = from.name;
    }
  },
  components: {
    Page: resolve => require(["@/components/common/Page.vue"],resolve),
    TwoDatePicker: resolve => require(["@/components/common/TwoDatePicker.vue"], resolve), // 双日期选择器组件
  },
  methods: {
    // 前往对账券卡详情页面
    toDetailPage(row) {
      let info = {
        accountsflag: this.queryInfo.accountsflag,
        directcode: this.queryInfo.directcode,
        flowdetailcode: this.queryInfo.flowdetailcode,
        flowname: this.queryInfo.flowname,
        paiTime: this.distributeForm.paiTime,
        outTime: this.distributeForm.outTime,
        cardkind: this.distributeForm.cardType,
      }
      sessionStorage.setItem('detailQueryInfo',JSON.stringify(info));
      this.$router.push({
        name: '券卡总数统计',
        query:{
          'cardkind': (this.ElementControls('accountbasis')!=1 || !row.kindcode)? row.cardkind:row.kindcode,
           bbindflowsend:this.distributeForm.bbindflowsend
        }
      })
    },
    // 接收选中的提货时间
    paiDateReceive(info) {
      if(info&&info.length>0) {
        this.distributeForm.paiTime[0] = info[0];
        this.distributeForm.paiTime[1] = info[1];
      } else {
        this.distributeForm.paiTime = [];
      }
    },
    // 接收选中的出库时间
    outDateReceive(info) {
      if(info&&info.length>0) {
        this.distributeForm.outTime[0] = info[0];
        this.distributeForm.outTime[1] = info[1];
      } else {
        this.distributeForm.outTime = [];
      }
    },
    // 对券卡输入值进行检索
    querySearchAsync(queryString, cb) {
      if(queryString) {
        api.GET_CARDKINDLIST({keyword: queryString}).then(res=>{
          if(res.data.status == "200") {
            if(res.data.data) {
              let dataArr = [];
              res.data.data.forEach(item => {
                let valInfo = {
                  value: item
                }
                dataArr.push(valInfo);
              })
              cb(dataArr);
            } else {
              b([]);
            }
          } else {
            cb([]);
          }
        })
      } else {
        cb([]);
      }
    },
    // 返回请求参数
    returnQueryInfo() {
      let detailParams = {
        accountsflag: this.queryInfo.accountsflag,
        directcode: this.queryInfo.directcode,
        flowdetailcode: this.queryInfo.flowdetailcode,
        startsubmitdate: this.distributeForm.paiTime.length>0?this.dateTime(this.distributeForm.paiTime[0]):'',
        endsubmitdate: this.distributeForm.paiTime.length>0?this.dateTime(this.distributeForm.paiTime[1]):'',
        startdate: this.distributeForm.outTime.length>0?this.dateTime(this.distributeForm.outTime[0]):'',
        enddate: this.distributeForm.outTime.length>0?this.dateTime(this.distributeForm.outTime[1]):'',
        cardkind: this.distributeForm.cardType,
        bbindflowsend: this.distributeForm.bbindflowsend
      };
      return detailParams;
    },
    // 获取门店对账收付款列表信息
    getAccountsDetail() {
      let detailParams = this.returnQueryInfo();
      detailParams.pageparam = {
        isnewcomp: 1, //是否需要重新统计页数
        pagesize: this.pageSize, //每页条数
        currentpage: this.currentPage, //当前页数
      }
      this.loading = true;
      api.GET_ACCOUNTSDETAIL(detailParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            this.payRecordList = res.data.data;
          }
          this.pagebBean = res.data.pagebean;
        } else {
          this.payRecordList = [];
          this.pagebBean = {
            totalnum: 0
          };
        }
        this.loading = false;
      }).catch(res => {
        this.loading = true;
      })
    },
    // 接收分页信息
    updatePage(size,num) {
      this.pageSize = size;
      this.currentPage = num;
      this.getAccountsDetail();
    },
    // 检索确定事件
    querySubmit() {
      this.currentPage = 1;
      this.getAccountsDetail();
    },
    // 导出数据列表
    exportStatistics() {
      let exportParams = this.returnQueryInfo();
      exportParams.flowname = this.queryInfo.flowname;
      exportParams.isappoint = 1;
      this.loading = true;
      api.GET_URLFORACCOUNTSDETAIL(exportParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            window.location.href = res.data.data;
            this.$message({
              type: 'success',
              message: res.data.message
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.loading = false;
      }).catch(res =>{
        this.loading = false;
      })
    },
    // 导出券卡详细列表
    exportAccountsCardDetail() {
      let exportParams = this.returnQueryInfo();
      // exportParams.flowname = this.queryInfo.flowname;
      this.loading = true;
      api.GET_URLFORACCOUNTSCARDDETAIL(exportParams).then(res => {
        if(res.data.status == "200") {
          if(res.data.data && res.data.data != 'null') {
            window.location.href = res.data.data;
            this.$message({
              type: 'success',
              message: res.data.message
            })
          }
        } else {
          this.$message({
            type: 'error',
            message: res.data.message
          })
        }
        this.loading = false;
      }).catch(res => {
        this.loading = false;
      })
    },
    //动态获取表格高度
    getHeight() {
      let tbHeight = this.$refs.gsTable.$el.offsetTop; //顶部检索条件占据的高度
      this.tableHeight = window.innerHeight - tbHeight - 130; 
      this.$nextTick(() => {
        this.$refs.gsTable.doLayout()
      })
    },
  },
  created() {
    //页面浏览器视窗变化绑定resize事件
    window.addEventListener("resize", this.getHeight);
  },
  mounted () {
    //在dom渲染之后
    setTimeout(()=>{
      this.getHeight();
    },200);
    if(sessionStorage.getItem('ticsQueryInfo')&&sessionStorage.getItem('ticsQueryInfo')!=undefined) {
      this.queryInfo = JSON.parse(sessionStorage.getItem('ticsQueryInfo'));
      if(this.queryInfo.directcode) {
        this.distributeForm = {
          cardType: "", //关键词
          paiTime: this.queryInfo.paiTime, // 提货时间
          outTime: this.queryInfo.outTime, // 出库时间
          bbindflowsend : this.$route.query.bbindflowsend
        }
        // 获取门店对账收付款列表信息
        this.getAccountsDetail()
      }
    }
  },
  destroyed(){ 
    window.removeEventListener('resize', this.getHeight); //销毁监听浏览器视窗变化
  },
  activated() {
    if(this.patchName != '券卡总数统计') {
      if(this.patchName) {
        this.distributeForm = {
          cardType: "", //关键词
          paiTime: [], // 提货时间
          outTime: [], // 出库时间
          bbindflowsend : this.$route.query.bbindflowsend
        }
        this.pageSize = 30; // 每页展示的条数
        this.currentPage = 1; // 当前请求的页数
        if(sessionStorage.getItem('ticsQueryInfo')&&sessionStorage.getItem('ticsQueryInfo')!=undefined) {
          this.queryInfo = JSON.parse(sessionStorage.getItem('ticsQueryInfo'));
          if(this.queryInfo.directcode) {
            this.distributeForm = {
              cardType: "", //关键词
              paiTime: this.queryInfo.paiTime, // 提货时间
              outTime: this.queryInfo.outTime, // 出库时间
              bbindflowsend : this.$route.query.bbindflowsend
            }
            // 获取门店对账收付款列表信息
            this.getAccountsDetail()
          }
        }
      }
    }
  },
}
</script>

<style scoped>
.mainPart {padding: 20px; height: calc(100% - 50px);}
.pdr70 {padding-right:70px;width:auto;display: block;}
.orderTable .hand{cursor: pointer;font-size: 14px;}
.orderTable .iconhand::before {
    font-size: 20px;
    padding-right: 5px;
    display: inline-block;
    vertical-align: top;
}
.shopName {color:var(--main-color); font-weight: 600; max-width: 250px;font-size: 14px;} 
.shopName:before {font-size: 16px;margin-right:5px;vertical-align: top;}
</style>


// WEBPACK FOOTER //
// src/views/StatisticsFolder/DealerStatistics/PaymentCardTotal.vue